/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Hero_Voice_BiologyInputs */

const en_homepage_hero_voice_biology = /** @type {(inputs: Homepage_Hero_Voice_BiologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biology`)
};

const es_homepage_hero_voice_biology = /** @type {(inputs: Homepage_Hero_Voice_BiologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biología`)
};

/**
* | output |
* | --- |
* | "Biology" |
*
* @param {Homepage_Hero_Voice_BiologyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_hero_voice_biology = /** @type {((inputs?: Homepage_Hero_Voice_BiologyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Hero_Voice_BiologyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_hero_voice_biology(inputs)
	return en_homepage_hero_voice_biology(inputs)
});